import { useMemo } from 'react';
import { gameTitle, formatDate } from '../../../lib/format';
import { useGET } from './useGET';

const toUrl = (
  leagueId,
  seasonId,
  teamId,
  stageId,
  page,
  pageSize,
  locked,
  homeAway,
  division,
  conference,
) => {
  let url = `/team/${teamId}/games/stats?ordering=-start_time&limit=${pageSize}&offset=${page *
    pageSize}&summary=1&league_id=${leagueId}&season_id=${seasonId}&locked=${locked}`;
  if (stageId) url += `&stage_id=${stageId}`;
  if (homeAway) url += `&side=${homeAway}`;
  if (division) url += `&division=${division}`;
  if (conference) url += `&conference=${conference}`;
  return url;
};

export function useTeamGames(
  leagueId,
  seasonId,
  team,
  stageId,
  pageSize = 100,
  locked = true,
  stats = true,
  homeAway = null,
  division = null,
  conference = null,
) {
  let url = team
    ? toUrl(
        leagueId,
        seasonId,
        team.id,
        stageId,
        0,
        pageSize,
        locked,
        stats,
        homeAway,
        division,
        conference,
      )
    : '';
  if (!stats) {
    url = url.replace('/stats', '');
  }
  const data = useGET(url);

  return useMemo(() => responseToTeamList(data), [data]);
}

function responseToTeamList(response) {
  if (!response) return;

  return response.results.map(game => ({
    id: game.id,
    name: `${gameTitle(game)} (${formatDate(game.start_time)})`,
  }));
}
